export default "__VITE_ASSET__D4uje1ez__"